/**
 * Filters features by platform and categories
 * @param {Object} sections - Object containing feature sections
 * @param {string} activeFilter - The active filter platform
 * @param {Set} activeCategoryFilters - Set of active category filters
 * @returns {Object} Filtered sections
 */
export const filterFeaturesByPlatform = (sections, activeFilter, activeCategoryFilters = new Set()) => {
  try {
    const filtered = Object.entries(sections || {}).map(([sectionName, features]) => {
      const filteredFeatures = (features || []).filter(feature => {
        // Safety check: ensure feature and platform exist
        if (!feature || !feature.platform || !Array.isArray(feature.platform)) {
          return false;
        }
        
        // Platform filter
        const platformMatch = activeFilter === 'All' || feature.platform.includes(activeFilter);
        
        // Category filter (only apply if there are active category filters)
        const categoryMatch = activeCategoryFilters.size === 0 || 
          (feature.category && activeCategoryFilters.has(feature.category));
        
        return platformMatch && categoryMatch;
      });
      
      return [sectionName, filteredFeatures];
    }).filter(([, features]) => features.length > 0); // Only keep sections with features
    
    return Object.fromEntries(filtered);
  } catch (error) {
    console.error('Error filtering features:', error);
    return {};
  }
};

/**
 * Counts visible years based on filters
 * @param {Array} featuresData - Array of year data
 * @param {string} activeFilter - The active filter platform
 * @param {Set} activeCategoryFilters - Set of active category filters
 * @returns {number} Number of visible years
 */
export const countVisibleYears = (featuresData, activeFilter, activeCategoryFilters = new Set()) => {
  return featuresData.filter((yearData) => {
    const filteredSections = filterFeaturesByPlatform(yearData.sections, activeFilter, activeCategoryFilters);
    return Object.keys(filteredSections).length > 0;
  }).length;
};